import { render } from "./SiteOverview.vue?vue&type=template&id=3f867e4f"
import script from "./SiteOverview.vue?vue&type=script&setup=true&lang=js"
export * from "./SiteOverview.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SitesDash/manage/SiteOverview.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3f867e4f"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3f867e4f', __exports__)) {
    api.reload('3f867e4f', __exports__)
  }
  
  module.hot.accept("./SiteOverview.vue?vue&type=template&id=3f867e4f", () => {
    api.rerender('3f867e4f', render)
  })

}


export default __exports__